import React, {useEffect, useState} from "react";
import {useNavigate} from "react-router-dom";
import Dropdown from "../dropdown/dropdown";
import {instanceMob} from "../../utils/utils";
import Topbar from "../top-bar/top-bar";
import StockContainer from "./components/stock-container";
import SalesCategoryPanel from "./components/sales-category-panel";
import CustomerStatementPanel from "./components/customer-statement-panel";
import IncomeExpenseChartPanel from "./components/income-expense-chart-panel";
import "./accounting.css";
import RecentMovementsPanel from "./components/recent-movements-panel";
import ProfitGoalsPanel from "./components/profit-goals-panel";
import DashboardCardsPanel from "./components/dashboard-cards-panel";
import useLocationStore from "./config/use-location-store";


const AccountingDashboard = () => {
    const navigate = useNavigate();
    const [locations, setLocations] = useState([]);
    const [financialSummary, setFinancialSummary] = useState([]);
    const [isLoadingSummary, setIsLoadingSummary] = useState(false);
    const {selectedLocation, setSelectedLocation} = useLocationStore();

    const getLocations = () => {
        return instanceMob
            .get(`admin/location/list`)
            .then((res) => res.data)
            .then((data) => setLocations(data))
            .catch((err) => console.error(err));
    };

    const getFinancialSummary = () => {
        if (!selectedLocation) return;

        setIsLoadingSummary(true);
        return instanceMob
            .get(`admin/accounting/financial-summary?location_id=${selectedLocation.id}`)
            .then((res) => res.data)
            .then((data) => setFinancialSummary(data))
            .catch((err) => console.error(err))
            .finally(() => setIsLoadingSummary(false));
    };

    useEffect(() => {
        getLocations();
        getFinancialSummary();
    }, [selectedLocation]);

    return (
        <>
            <div className="accounting-main w-100">
                <Topbar/>
                <div className="accounting w-100 p-3 px-5 gap-4 d-flex flex-column">
                    <div className="d-flex flex-row justify-content-between align-items-center">
                        <div className="d-flex flex-row gap-1 justify-content-center align-items-center">
                            <button
                                type="button"
                                className="btn close-button p-1"
                                onClick={() => navigate(-1)}
                            >
                                <svg xmlns="http://www.w3.org/2000/svg" width="36" height="36" viewBox="0 0 36 36"
                                     fill="none">
                                    <path
                                        d="M25.5811 34.4648H9.88379C4.97749 34.4648 1 30.4874 1 25.5811V9.88379C1 4.97749 4.97749 1 9.88379 1H25.5811C30.4874 1 34.4648 4.97749 34.4648 9.88379V25.5811L34.4531 26.0381C34.223 30.5807 30.5807 34.223 26.0381 34.4531L25.5811 34.4648Z"
                                        stroke="#9DACBD" stroke-width="2"/>
                                    <path
                                        d="M11.0018 17.6351C11.0018 17.0388 11.2292 16.4425 11.6842 15.9875L20.7139 6.95782C21.6238 6.04792 23.0991 6.04792 24.009 6.95782C24.9189 7.86772 24.9189 9.34307 24.009 10.253L16.6268 17.6351L24.009 25.0172C24.9189 25.9271 24.9189 27.4024 24.009 28.3124C23.0991 29.2223 21.6238 29.2223 20.7139 28.3124L11.6842 19.2827C11.2292 18.8277 11.0018 18.2313 11.0018 17.6351Z"
                                        fill="#9DACBD"/>
                                </svg>
                            </button>
                            <div className="close-button-label">Volver</div>
                        </div>
                        <div className="accounting-dashboard-title">
                            Panel de Control Interno – Ingresos, Stock y Clientes
                        </div>
                        <div>
                            <Dropdown
                                label="Locación"
                                items={[
                                    {id: "", name: "Todas las sedes"},
                                    ...locations.map((loc) => ({
                                        id: loc.id,
                                        name: loc.name,
                                    })),
                                ]}
                                onSelect={(selectedLoc) => {
                                    setSelectedLocation(selectedLoc);
                                }}
                                placeholder="Selecciona tu locación"
                                showLabel={false}
                                initialValue={selectedLocation?.name}
                            />
                        </div>
                    </div>
                    <DashboardCardsPanel
                        financialSummary={financialSummary}
                        isLoading={isLoadingSummary}
                    />
                    <div className="row align-items-end">
                        <div className="col-9 col-xxl-9">
                            <IncomeExpenseChartPanel/>
                        </div>
                        <div className="col-3 col-xxl-3">
                            <StockContainer/>
                        </div>
                    </div>
                    <div className="row align-items-end">
                        <div className="col-6 col-xxl-6">
                            <SalesCategoryPanel/>
                        </div>
                        <div className="col-6 col-xxl-6">
                            <CustomerStatementPanel/>
                        </div>
                    </div>
                    <RecentMovementsPanel/>
                    <ProfitGoalsPanel/>
                </div>
            </div>
        </>
    );
};

export default AccountingDashboard;
